import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const numIcon = (label, cls) => L.divIcon({
  className: "",
  html: `<div style="width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:13px;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4);${cls}">${label}</div>`,
  iconSize: [28, 28], iconAnchor: [14, 14],
});

export default function RouteMap({ start, stops }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!ref.current || !start) return;
    if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; }
    const map = L.map(ref.current, { scrollWheelZoom: false });
    mapRef.current = map;
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);
    const pts = [[start.lat, start.lng], ...stops.map((s) => [s.lat, s.lng])];
    L.polyline(pts, { color: "#1b4332", weight: 3, opacity: 0.85, dashArray: "6 6" }).addTo(map);
    L.marker([start.lat, start.lng], { icon: numIcon("S", "background:#1b4332;color:#fff;") })
      .addTo(map).bindPopup(`<b>Start</b><br/>${start.label}`);
    stops.forEach((s, i) => {
      L.marker([s.lat, s.lng], { icon: numIcon(String(i + 1), "background:#d4a531;color:#1b4332;") })
        .addTo(map).bindPopup(`<b>${i + 1}. ${s.business || s.line1}</b><br/>${[s.line1, s.city].filter(Boolean).join(", ")}`);
    });
    map.fitBounds(L.latLngBounds(pts), { padding: [30, 30] });
    return () => { if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } };
  }, [start, stops]);

  return <div ref={ref} data-testid="route-map" className="h-72 w-full overflow-hidden rounded-lg border border-border sm:h-80" />;
}
